export class SetLEDColorAction {
    constructor(red, green, blue) {
        this.name = 'SetLEDColor';
        this.isDeviceAction = true;
        this.data = { red, green, blue };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2V0TEVEQ29sb3JBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL1NldExFRENvbG9yQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLE1BQU0sT0FBTyxpQkFBaUI7SUFLNUIsWUFBWSxHQUFXLEVBQUUsS0FBYSxFQUFFLElBQVk7UUFKcEMsU0FBSSxHQUFHLGFBQWEsQ0FBQztRQUNyQixtQkFBYyxHQUFHLElBQUksQ0FBQztRQUlwQyxJQUFJLENBQUMsSUFBSSxHQUFHLEVBQUUsR0FBRyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsQ0FBQztJQUNuQyxDQUFDO0NBQ0YifQ==